function getImageSize(imgUrl, callback) {
    var image = new Image();
    image.src = imgUrl;
    image.onload = function () {
        callback(image.width, image.height);
        image.onload = null;
    };
}
export default getImageSize;
//# sourceMappingURL=getImageSize.js.map